import { useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

import { useBlogModalContent } from "./hooks";

import { ArticleModalContent } from "common";

import { convertRawToHtml, generateImageLink } from "utils";

export interface BlogModalContentProps {
  setCurrentBlogId: (value: number | string) => void;
}

export const BlogModalContent = ({
  setCurrentBlogId,
}: BlogModalContentProps) => {
  const { id } = useParams();
  const { blogContent } = useBlogModalContent({ id: Number(id) });

  useEffect(() => {
    if (id) setCurrentBlogId(id);
  }, [id]);

  return (
    <>
      <ArticleModalContent
        type="Blog"
        sliderContent={blogContent}
        image={generateImageLink({ imageId: blogContent?.cover_image })}
        date={moment(blogContent?.created_at).format("DD/MM/YYYY")}
        title={blogContent?.title}
        text={convertRawToHtml(blogContent?.content)}
      />
    </>
  );
};
